import { HttpClient } from "@angular/common/http";
import { Injectable, forwardRef, inject } from "@angular/core";
import { CreatePlan } from "../interfaces/plan.interface";
import { UpdatePlan } from "../interfaces/plan.interface";
import { Observable } from "rxjs";
import { Plan } from "../interfaces/plan.interface";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable()
export class PlanService {

  apiUrl = inject(forwardRef(() => API_URL));
  baseUrl = `${this.apiUrl}/plans`
  http = inject(HttpClient);

  create(payload: CreatePlan): Observable<{id: string}> {
    return this.http.post<{id: string}>(this.baseUrl, payload);
  }

  update(id: string, payload: UpdatePlan): Observable<any> {
    return this.http.post(`${this.baseUrl}/update/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/delete/${id}`, {});
  }

  getAll(): Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.baseUrl}`);
  }
}